import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_locations_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId: number, typeId: number, fullTextSearch?: string, isLoose?: boolean, eligibleForAllocation?: boolean, parentId?: number, locationId?: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.typeId)) {
      missingRequiredInParams.push('\'typeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_locations_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId: number, typeId: number, fullTextSearch?: string, isLoose?: boolean, eligibleForAllocation?: boolean, parentId?: number, locationId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, TypeId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.typeId)) {
      missingRequiredInParams.push('\'typeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_locations_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId: number, typeId: number, fullTextSearch?: string, isLoose?: boolean, eligibleForAllocation?: boolean, parentId?: number, locationId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, TypeId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.typeId)) {
      missingRequiredInParams.push('\'typeId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_locations_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId: number, typeId: number, fullTextSearch?: string, isLoose?: boolean, eligibleForAllocation?: boolean, parentId?: number, locationId?: number    }) {
        if(isNil(inParams.warehouseId)) {
          return true; 
        }
        if(isNil(inParams.typeId)) {
          return true; 
        }
      return false;
    }
}
